import { InputSwitch, Button } from "@endya-conformite/ui-kit";
import ChevronLeft from "@endya-conformite/ui-kit/src/assets/icons/chevron-left.svg?react";
import ChevronRight from "@endya-conformite/ui-kit/src/assets/icons/chevron-right.svg?react";
import Loader from "@endya-conformite/ui-kit/src/assets/loader.svg?react";
import { AxeFormValues } from "./ControleQuinquennalAxe";
import style from "./ControleQuinquennalPageActions.module.scss";

type ControleQuinquennalPageActionsProps = {
  onNext?: () => void;
  onPrevious?: () => void;
  isLoading: boolean;
  isLast: boolean;
  isValid: boolean;
  onAddComment: () => void;
};

export function ControleQuinquennalPageActions({
  onNext,
  onPrevious,
  isLoading,
  isLast,
  isValid,
  onAddComment,
}: ControleQuinquennalPageActionsProps) {
  return (
    <div className={style.actions}>
      <div>
        {onPrevious && (
          <Button
            onClick={onPrevious}
            disabled={isLoading}
            icon={isLoading ? <Loader /> : <ChevronLeft />}
            variant="text"
          >
            Précédent
          </Button>
        )}
      </div>
      <div className={style.right}>
        <Button onClick={onAddComment} variant="outline">
          Envoyer un commentaire à l&apos;équipe de vérificateurs
        </Button>
        <div>
          <InputSwitch<AxeFormValues>
            label="Import complet"
            name="complet"
            className={style.switch}
            disabled={!isValid}
          />
        </div>
        <div>
          {onNext && (
            <Button
              onClick={onNext}
              variant="text"
              disabled={isLoading}
              icon={isLoading ? <Loader /> : <ChevronRight />}
              className={style.next}
            >
              {isLast ? "Enregistrer" : "Suivant"}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
